// 2D grid geometry in px. The 3D view renders into an SVG of the same size, so switching views doesn't shift the layout.
export const HEATMAP_GRID_LAYOUT = {
  cellSize: 15,
  cellGap: 5,
  daysInWeek: 7,
  margin: {
    top: 20, right: 10, bottom: 5, left: 30,
  },
  dayLabelOffset: 6,
  monthLabelOffset: 8,
};

export const HEATMAP_DAY_LABELS = [
  { day: 1, label: 'Mon' },
  { day: 3, label: 'Wed' },
  { day: 5, label: 'Fri' },
];

// Camera angles are in degrees; yawDeg must stay between 0 and 90 because only the bar faces turned towards the camera are drawn.
// Heights and gap are in day-cell units; padding, offsets and font sizes are in px.
// Tuned on 5-month sample data so the chart fills the widget's width while both side faces stay visible.
export const HEATMAP_3D_SETTINGS = {
  yawDeg: 18,
  elevationDeg: 30,
  // Days without scans are thin slabs; days with scans grow from minBarHeight to maxBarHeight by count
  emptyCellHeight: 0.14,
  minBarHeight: 0.45,
  maxBarHeight: 1.6,
  cellGap: 0.2,
  // Flat shading as brightness multipliers: lit top, half-shaded front, shaded side
  faceBrightness: {
    top: 1,
    front: 0.84,
    side: 0.7,
  },
  // Same-color outline that closes the anti-aliasing seams between faces of one bar
  faceSeamStrokeWidth: 0.6,
  // Themed in themes.scss, so empty slabs follow light/dark mode without a re-render
  emptyFaceColors: {
    top: 'var(--heatmap-3d-empty-top, #e7e9ee)',
    front: 'var(--heatmap-3d-empty-front, #c2c4c8)',
    side: 'var(--heatmap-3d-empty-side, #a2a3a7)',
  },
  hoverHighlight: {
    color: '#ffffff',
    ratio: 0.3,
  },
  growAnimation: {
    durationMs: 900,
    weekStaggerMs: 18,
  },
  // Left fits the Mon/Wed/Fri labels, bottom fits the month labels in front of the grid
  padding: {
    top: 4, right: 4, bottom: 16, left: 40,
  },
  labelFontSize: 10,
  // Wide enough that the tallest bars in the first week can't reach over the day labels
  dayLabelOffset: 18,
  monthLabelOffset: 7,
};
